import { Container, Typography } from '@mui/material';

const Academics = () => {
  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Academics
      </Typography>
      <Typography variant="body1">
        We offer a well-structured curriculum covering core subjects along with extracurricular activities.
      </Typography>
    </Container>
  );
};

export default Academics;
